(function(angular, _) {
    'use strict';

    /**
     * An interface definition of an observer.
     * @interface
     */
    /* function ObserverInterface() {}
     * ObserverInterface.prototype.notify = function() {};
     */

    /**
     * This factory will provide an observer (subject) that informs its dependents (observers) about keys pressed.
     */
    angular.module('wtApp.KeyboardNavigation').factory('KeyboardListener', KeyboardListener);
    KeyboardListener.$inject = ['$document'];
    function KeyboardListener($document) {
        var observerCollection = [];

        /**
         * Iterates over the list of observers and calls the notify method of each with e as an parameter.
         * @param {Object} e A keypress event send by hitting any key on the keyboard.
         */
        var notifyObservers = function(e) {
            _.forEach(observerCollection, function(observer) {
                if (!_.isObject(observer) || typeof observer.notify === 'undefined'
                    || !_.isFunction(observer.notify)) {
                    return;
                }

                observer.notify(e);
            });
        };

        /**
         * Register on the keydown event and start to notify the observers.
         */
        $document.on('keydown', function(e) {
            if (!observerCollection.length) {
                return;
            }

            notifyObservers(e);
        });

        return {
            /**
             * Checks whether or not observer is of the right type (has member function called notify) and adds it to the
             * list of observers.
             * @param {{notify: Function}} observer An object that implements the notify method.
             * @returns {boolean}
             */
            registerObserver: function(observer) {
                if (!observer || !_.isObject(observer) || typeof observer.notify === 'undefined'
                    || !_.isFunction(observer.notify)) {
                    return false;
                }

                var length = observerCollection.length;
                var newLength = observerCollection.push(observer);

                return newLength > length;
            },

            /**
             * Remove the given observer from the list of observers.
             * @param {Object} observer An object that has been added as an observer previously.
             * @returns {Array<Object>}
             */
            unregisterObserver: function(observer) {
                if (!observer) {
                    return [];
                }

                return _.remove(observerCollection, observer);
            }
        };
    }
})(window.angular, window._);
